
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0544dbbd&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RecordDemand.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RecordDemand.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0544dbbd!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RecordDemand.vue"),
  /* scopeId */
  "data-v-0544dbbd",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/anchor/helpCenter/RecordDemand.vue
// module id = 372
// module chunks = 0